import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import User from "../img/User.svg";
import Sort from "../img/Sort.svg";
import Expand_left from "../img/Expand_left.svg";
import notificationLog from "../img/notificationLog.svg";

const HeaderAddApp = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname.toLowerCase();

  const getActiveTab = (path) => pathname.startsWith(path.toLowerCase());

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <div>
      <div className="w-full h-16 sticky top-0 flex items-center z-50 justify-between px-5 bg-[#4C3A68] ">
        {/* Left Section: Logo and Search Bar */}
        <div className="flex items-center gap-4 flex-1">
          <img src={Expand_left} alt="" onClick={() => navigate(-1)} className="rounded-full hover hover:bg-[#5E4D77] cursor-pointer" />
        </div>

        {/* Mobile Hamburger Icon */}
        <div className="sm:hidden flex items-center">
          <button
            onClick={toggleMobileMenu}
            className="text-white focus:outline-none"
          >
            <img
              src={Sort} // New logo for mobile
              alt="Hamburger Menu"
              className="w-6 h-6"
            />
          </button>
        </div>

        {/* new */}

        <div className="hidden sm:flex items-center gap-3 sm:gap-5 text-white text-xs sm:text-sm flex-1 justify-end">
          {[
            { path: "/dashboard", label: "Dashboard" },
            { path: "/myApplication", label: "My Application" },
            { path: "/salesReport", label: "Sales Report" },
          ].map(({ path, label }) => (
            <span
              key={path}
              onClick={() => {
                navigate(path);
                setIsMobileMenuOpen(false); // if you also want to close a mobile menu
              }}
              role="link"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate(path);
                  setIsMobileMenuOpen(false);
                }
              }}
              className={` border-b-2 transition relative cursor-pointer ${
                getActiveTab(path)
                  ? "border-[#9061DB] font-semibold"
                  : "border-transparent hover:border-[#9061DB] font-semibold"
              }`}
            >
              {label}
            </span>
          ))}

          <NavLink to="/notifications">
            {({ isActive }) => (
              <div
                className={`rounded-full p-2 transition ${
                  isActive ? "bg-[#5D4D76]" : "hover:bg-[#5D4D76]"
                }`}
              >
                <img src={notificationLog} alt="Profile" className="h-6 w-6" />
              </div>
            )}
          </NavLink>

          {/* Profile Icon */}
          <NavLink to="/profile">
            {({ isActive }) => (
              <div
                className={`rounded-full p-2 transition ${
                  isActive ? "bg-[#5D4D76]" : "hover:bg-[#5D4D76]"
                }`}
              >
                <img src={User} alt="Profile" className="h-6 w-6" />
              </div>
            )}
          </NavLink>
        </div>

        {/* Mobile Menu Links (hidden on desktop) */}

        <div
          className={`${
            isMobileMenuOpen ? "block" : "hidden"
          } sm:hidden absolute top-16 left-0 w-full bg-[#4C3A68] text-white z-10 p-5 shadow-md`}
        >
          <div className="flex flex-col gap-4">
            {[
              { path: "/dashboard", label: "Dashboard" },
              { path: "/myApplication", label: "My Application" },
              { path: "/salesReport", label: "Sales Report" },
            ].map(({ path, label }) => (
              <NavLink
                key={path}
                to={path}
                className={`pb-1 border-b-2 transition relative ${
                  getActiveTab(path)
                    ? "border-white font-semibold"
                    : "border-transparent hover:border-gray-300 font-semibold"
                }`}
              >
                {label}
              </NavLink>
            ))}

            <NavLink to="/notifications">
              {({ isActive }) => (
                <div
                  className={`rounded-full p-2 transition ${
                    isActive ? "bg-[#5D4D76]" : "hover:bg-[#5D4D76]"
                  }`}
                >
                  <img
                    src={notificationLog}
                    alt="Profile"
                    className="h-6 w-6"
                  />
                </div>
              )}
            </NavLink>

            <NavLink to="/profile">
              {({ isActive }) => (
                <div
                  className={`rounded-full p-2 transition ${
                    isActive ? "bg-[#5D4D76]" : "hover:bg-[#5D4D76]"
                  }`}
                >
                  <img src={User} alt="Profile" className="h-6 w-6" />
                </div>
              )}
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderAddApp;
